import React from 'react';
import { useMetaPixel } from '../hooks/useMetaPixel';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { SolutionSection } from '../components/SolutionSection';
import { SocialProofSection } from '../components/SocialProofSection';
import { OfferSection } from '../components/OfferSection';
import { FAQSection } from '../components/FAQSection';
import { FooterCTA } from '../components/FooterCTA';
import { Footer } from '../components/Footer';
import { LiveNotification } from '../components/LiveNotification';
export function LandingPage() {
  useMetaPixel();
  return <main className="min-h-screen bg-[#0a0a0a] text-white selection:bg-[#25D366] selection:text-black font-sans" data-id="element-257">
      <UrgencyBar data-id="element-258" />
      <HeroSection data-id="element-259" />
      <PainSection data-id="element-260" />
      <SolutionSection data-id="element-261" />
      <SocialProofSection data-id="element-262" />
      <OfferSection data-id="element-263" />
      <FAQSection data-id="element-264" />
      <FooterCTA data-id="element-265" />
      <Footer data-id="element-266" />
      <LiveNotification data-id="element-267" />
    </main>;
}